export default {
    '抱歉！没有找到该页面': '抱歉！没有找到该页面',
    返回首页: '返回首页'
}
